/**
 * @class Checked
 * @classdesc 正则验证
 * @constructor
 * @desc 不需要构造函数 直接使用类
 * @TODO 未处理IE6-8的兼容性
 */

import { checkNull } from "../filters/filters";

export default class Checked {
  constructor() {
    this.flag = false;
    this.timer = null;
  }

  /**
   * 验证密码格式
   * */
  static checkPwd(value) {
    // var patrn = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/;
    var patrn = /^(?![a-zA-z]+$)(?!\d+$)(?![!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]+$)(?![a-zA-z\d]+$)(?![a-zA-z!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]+$)(?![\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]+$)[a-zA-Z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,12}$/;
    if (!patrn.exec(value)) return false;
    return true;
  }

  /**
   * 验证邮箱格式
   * */
  static checkEmail(val) {
    let isok;
    if (val != "") {
      var reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
      isok = reg.test(val);
      if (!isok) {
        return false;
      } else {
        return true;
      }
    }
  }

  /**
   * 身份证验证 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
   * true 为通过
   * */
  static checkIdCard(cardNo) {
    var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    let res = reg.test(cardNo);
    if (!res) {
      return false;
    }
    return res;
  }

  /**
   * 身份证验证 税务号码
   * true 为通过 |^[A-Z0-9]{20}$
   * */
  static checkTaxRegistrationNo(taxRegistrationNo) {
    var reg = /^[A-Z0-9]{15}$|^[A-Z0-9]{18}$/;
    let res = reg.test(taxRegistrationNo);
    if (!res) {
      return false;
    }
    return res;
  }

  /**
   * Form
   * 判断输入是否为合法的手机号码 true为符合
   * */
  static checkPhoneNumber(phoneNum) {
    // 此处校验有问题
    // var reg_mobile = /^1([358][0-9]|4[579]|66|7[01235678]|9[189])[0-9]{8}$/;
    var reg_mobile = /^1[3-9][0-9]{9}$/;
    let res = reg_mobile.test(phoneNum);
    return res;
    // if (!res) {
    //     return false
    // }
    // return true;
  }

  // 判断输入只能为中文或者英文
  static checkChinseEnglish(value) {
    if (!value.replace(/[^\w\.\/]/g, "")) {
      return false;
    }
    return true;
  }

  // 银行卡校验
  static checkBankCard(value) {
    var num = /^\d*$/;
    if (value.length < 16 || value.length > 19 || !num.test(value)) {
      return false;
    }
    return true;
  }

  // 检验是否最多两位小数
  static checkTwoPoint(number) {
    if (checkNull(number)) {
      return false;
    }
    var partten = /^\d+(\.\d{1,2})?$/;
    return partten.test(number);
  }

  // 检验一位小数
  static checkOnePoint(number) {
    if (checkNull(number)) {
      return false;
    }
    var reg = /^\d+(\.\d{1})?$/;
    return reg.test(number);
  }

  // 检验6位手机验证码
  static checkSixVerifyCode(value) {
    var num = /^\d*$/;
    if (value.length !== 6 || !num.test(value)) {
      return false;
    }
    return true;
  }

  // 检验数字
  static checkNum(value) {
    var reg_num = /^[0-9]*$/;
    let res = reg_num.test(value);
    if (!res) {
      return false;
    }
    return true;
  }

  // 限制手机号的长度
  static checkIphoneLength(value) {
    if (value.length > 11) {
      return false;
    }
    return true;
  }

  // 校验中文
  static checkChinese = str => {
    if (checkNull(str)) {
      return false;
    }

    var partten = /[\u4E00-\u9FA5\uF900-\uFA2D]/;
    return partten.test(str);
  };

  // 校验金额，且3位一个逗号隔开（3位一个逗号可有可没有）
  static checkPriceToThousands(value) {
    if (checkNull(value)) {
      return false;
    }
    var partten = /^([0-9]+|[0-9]{1,3}(,[0-9]{3})*)(.[0-9]{1,2})?$/;
    return partten.test(value);
  }

  // 长度限制
  static checkFieldLength = str => {
    return str.length >= 4 && str.length <= 32;
  };

  // 五位数字或字母
  static checkAccountNumberLength = str => {
    if(str.length <= 5) {
      return false;
    }
    let partten = /^[A-Za-z0-9]+$/;
    return partten.test(str);
  };
}



// WEBPACK FOOTER //
// ./src/FormVerification/checkd.js